import React from 'react';
import _ from 'lodash';
import { isValidPassword } from 'helpers/Account';
import ParentalControls from '../AccountComponents/ParentalControls';
import { fetchPCS, setPCS } from '../AccountComponents/ParentalControls/ParentalControlsActions';

import Style from '../SharedStyles/SharedStyles.module.scss';

function getRatingImageURL(rating) {
  const baseSlug = _.get(window.ExternalConfig, 'baseUrlSlug', '');
  return `${baseSlug}/static/images/ratings/${rating}-min.png`;
}

function onParentalControlsBackClick() {
  this.toggleParentalControls();
  this.toggleAccountMain();
}

function setParentalControlsPasswordErrors(cb) {
  const { parentalControlsPassword } = this.state;
  const parentalControlsPasswordError = !isValidPassword(parentalControlsPassword);
  const setStateCb = () => {
    const { parentalControlsPasswordError } = this.state;
    const hasErrors = parentalControlsPasswordError || false;
    if (cb) return cb(hasErrors);
    return hasErrors;
  };
  return this.setState(
    {
      parentalControlsPasswordError,
    },
    setStateCb,
  );
}

function onVerifyPassword() {
  const {
    account: { email },
    login,
  } = this.props;
  const { parentalControlsPassword } = this.state;
  const handleSuccess = () => {
    this.setState({
      parentalControlsPasswordVerified: true,
      showAccountMain: false,
      showParentalControls: true,
    });
  };
  setParentalControlsPasswordErrors.bind(this)(hasErrors => {
    if (!hasErrors && login) {
      const body = {
        password: parentalControlsPassword,
        email,
      };
      login(body, result => {
        const { error } = result;
        if (error) return this.setState({ parentalControlsPasswordError: error.message });
        return handleSuccess();
      });
    }
  });
}

async function onSaveParentalControls(pcs) {
  const { account } = this.props;
  const { tv_rating_val, mv_rating_val } = pcs;
  const {
    parentalControlsNewTvRatingIndex: newTvIdx,
    parentalControlsNewMovieRatingIndex: newMovieIdx,
  } = this.state;
  const {
    pcsRatings: { tv, mpaa: allMovieRatings },
  } = window.ExternalConfig;

  const allTvRatings = _.filter(tv, 'parentalControlEnabled');

  const newPCS = {};

  if (newTvIdx !== null) {
    newPCS.tv_rating_val = _.get(allTvRatings, `${newTvIdx}.id`, '').toUpperCase();
  } else {
    newPCS.tv_rating_val = tv_rating_val;
  }

  if (newMovieIdx !== null) {
    newPCS.mv_rating_val = _.get(allMovieRatings, `${newMovieIdx}.id`, '').toUpperCase();
  } else {
    newPCS.mv_rating_val = mv_rating_val;
  }

  try {
    if (account) {
      await setPCS(account.accessToken, newPCS);
      await fetchPCS(account.accessToken);
    }
  } catch (err) {
    console.log(err);
  }

  this.toggleParentalControls();
  this.toggleAccountMain();
}

export default function renderParentalControls() {
  const { account, backgroundClass, isMobile, language, pcs } = this.props;
  const { profileSignin_forgotPasswordText: linkText, profile_pcsHeader: headerText } =
    language || {};
  const {
    showParentalControls,
    parentalControlsPasswordVerified,
    parentalControlsPassword,
    parentalControlsShowPassword,
    parentalControlsPasswordError,
    parentalControlsNewTvRatingIndex,
    parentalControlsNewMovieRatingIndex,
  } = this.state;
  const parentalControlsBackClick = onParentalControlsBackClick.bind(this);
  const ratingImageURL = getRatingImageURL.bind(this);
  const saveParentalControls = onSaveParentalControls.bind(this);
  const verifyPassword = onVerifyPassword.bind(this);
  const headerProps = {
    headerText,
    iconMobile: <button onClick={() => parentalControlsBackClick()} className={Style.back} />,
    isDesktop: !isMobile,
    onClose: opts => this.onClose(opts),
    renderLogo: this.renderLogo,
    showHeaderDesktop: true,
  };
  const forgotPasswordCTAProps = {
    linkText,
    onClick: () => {
      if (this.onForgotPasswordClick) this.onForgotPasswordClick();
    },
  };

  const handleTvRatingChange = newIndex => {
    this.setState({ parentalControlsNewTvRatingIndex: newIndex });
  };

  const handleMovieRatingChange = newIndex => {
    this.setState({ parentalControlsNewMovieRatingIndex: newIndex });
  };

  const parentalControlsProps = {
    account,
    backgroundClass,
    forgotPasswordCTAProps,
    getRatingImageURL: ratingImageURL,
    handleMovieRatingChange,
    handleTvRatingChange,
    headerProps,
    language,
    onFieldChange: this.onFieldChange,
    onParentalControlsBackClick: parentalControlsBackClick,
    onSaveParentalControls: saveParentalControls,
    onVerifyPassword: verifyPassword,
    parentalControlsNewMovieRatingIndex,
    parentalControlsNewTvRatingIndex,
    parentalControlsPassword,
    parentalControlsPasswordError,
    parentalControlsPasswordVerified,
    parentalControlsShowPassword,
    pcs,
  };
  if (!showParentalControls) return null;
  return <ParentalControls {...parentalControlsProps} />;
}
